import React, { useRef } from "react";
import styles from "./DashboardImageSlider.module.css";
import { Card, CardContent, Typography, Chip, IconButton } from "@mui/material";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";

const slides = [
  {
    id: 1,
    title: "YOUR IMAGES WITH LEONARDO.AI",
    category: "Upscaling",
    image: "https://img.freepik.com/premium-photo/plain-background_847512-1896.jpg",
  },
  {
    id: 2,
    title: "STYLE REFERENCE",
    category: "How to Use",
    image: "https://img.freepik.com/premium-photo/plain-background_847512-1896.jpg",
  },
  {
    id: 3,
    title: "CONSISTENT CHARACTERS",
    category: "Creating",
    image: "https://img.freepik.com/premium-photo/plain-background_847512-1896.jpg",
  },
  {
    id: 4,
    title: "GAMING CHARACTERS",
    category: "Creating",
    image: "https://img.freepik.com/premium-photo/plain-background_847512-1896.jpg",
  },
  {
    id: 5,
    title: "ANIME CHARACTERS",
    category: "Creating",
    image: "https://img.freepik.com/premium-photo/plain-background_847512-1896.jpg",
  },
];

const DashboardImageSlider = () => {
  const scrollRef = useRef(null);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 320; // Adjust for smooth movement
      scrollRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className={styles.sliderContainer}>
      <div className={styles.cardContainer} ref={scrollRef}>
        {slides.map((slide) => (
          <Card
            key={slide.id}
            className={styles.card}
            style={{ backgroundImage: `url(${slide.image})` }}
          >
            <CardContent className={styles.cardContent}>
              <Chip label={slide.category} className={styles.chip} />
              <Typography variant="h6" className={styles.title}>
                {slide.title}
              </Typography>
            </CardContent>
          </Card>
        ))}
      </div>

      {/* Navigation Buttons Positioned Over the Slider */}
      <IconButton className={`${styles.navButton} ${styles.leftButton}`} onClick={() => scroll("left")}>
        <ArrowBackIos />
      </IconButton>

      <IconButton className={`${styles.navButton} ${styles.rightButton}`} onClick={() => scroll("right")}>
        <ArrowForwardIos />
      </IconButton>
    </div>
  );
};

export default DashboardImageSlider;
